import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Input from '@material-ui/core/Input';
import Popover from '@material-ui/core/Popover';
import moment from 'moment';

import ClearIcon from '~/components/icons/ClearIcon';

import Calendar from './Calendar';
import styles from './index.style.js';

class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.inputRef = React.createRef();

    const { defaultValue, defaultStartDate } = props;

    this.state = {
      value: defaultValue && moment(defaultValue),
      startDate: defaultStartDate,
      calendarOpen: false,
    };
  }

  openCalendar = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.inputRef.blur();
    this.setState({ calendarOpen: true });
  };

  closeCalendar = () => this.setState({ calendarOpen: false });

  onDateChange = (value) => {
    this.setState(
      {
        value,
        calendarOpen: false,
      },
      () => this.props.onChange(this.state.value.format('YYYY-MM-DD')),
    );
  };

  clearValue = (e) => {
    this.setState({ value: '' }, () => this.props.onChange(this.state.value));
    e.stopPropagation();
    e.preventDefault();
  };

  render = () => {
    const { value, calendarOpen, startDate } = this.state;

    const {
      label,
      classes,
      variant,
      minDate,
      maxDate,
      clearable,
      placeholder,
    } = this.props;

    const input = (
      <Input
        className={classes.inputRoot}
        variant={variant}
        inputRef={(ref) => (this.inputRef = ref)}
        onFocus={this.openCalendar}
        value={(value && value.format('MMM D, YYYY')) || ''}
        placeholder={placeholder}
        endAdornment={
          clearable &&
          value && (
            <ClearIcon
              className={classes.clearIcon}
              onClick={this.clearValue}
              height={13}
              width={13}
            />
          )
        }
      />
    );

    return (
      <>
        {label ? (
          <FormControl>
            <FormLabel>{label}</FormLabel>
            {input}
          </FormControl>
        ) : (
          input
        )}
        <Popover
          onClose={this.closeCalendar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          anchorEl={this.inputRef}
          open={calendarOpen}>
          <Calendar
            classes={classes}
            startDate={startDate}
            minDate={minDate}
            maxDate={maxDate}
            selectedDate={value || moment()}
            dateChange={this.onDateChange}
          />
        </Popover>
      </>
    );
  };
}

DatePicker.defaultProps = {
  startDate: moment().format('YYYY-MM-DD'),
  maxDate: null,
  variant: 'standard',
  clearable: false,
  placeholder: 'Choose a date',
};

DatePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  defaultStartDate: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  variant: PropTypes.string,
  clearable: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultValue: function(props, propName) {
    if (!props[propName]) return;
    if (!/\d{4}-\d{2}-\d{2}/.test(props[propName])) {
      return new Error(
        'Invalid prop `' +
          propName +
          '` supplied to' +
          ' DatePicker. Must be a date string in format YYYY-MM-DD.' +
          ` Received ${props[propName]}`,
      );
    }
  },
};

export default withStyles(styles)(DatePicker);
